import { Typo } from "@pepperstone/pepper-ui-kit";

export const BodyTypo = ({
  text,
  alignEnd = false,
}: {
  text?: string | number;
  alignEnd?: boolean;
}) => (
  <Typo
    elem="p"
    size="md"
    type="body"
    clamp="ps-line-clamp-1"
    responsiveClasses={alignEnd ? "text-end" : ""}
  >
    {text}
  </Typo>
);
